import { ElementRef, HostListener } from '@angular/core';
import { Input } from '@angular/core';
import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { Pipe, PipeTransform } from '@angular/core';

@Directive({
  selector: '[appNumberdirective]'
})
export class NumberdirectiveDirective {

  //allowSpecialChars = /^[a-zA-Z0-9\s&\/\\#,+()$%.€'":*?<->-{}@!]+$/
  allowSpecialChars = /^[a-zA-Z0-9\s&\/\\#,+()£$%.€'":*?<>{}@!;\-\. \n\u0024\u00A2\u00A3\u00A4\u00A5\u20A0-\u20CF]+$/;  //This will allow 36 Currency symbolls
  name: 'password'
  Mobile = /^([+0-9])*$/
  Telephone = /^([0-9-+() ])*$/
  AccountNumber = /^([0-9])*$/
  TaxReferenceNumber = /^([0-9])*$/
  MinusValue = /^([0-9-])*$/
  stringPattern = /^([A-Za-z ])*$/
  //companyname = /^([A-Za-z0-9 &'\(\)\@,\-\./ ])*$/
  companyname = /^([A-Za-z 0-9 &(),./'-])*$/
  postcode = /^([A-Za-z0-9 ])*$/
  companyAuthenticationcode = /^([A-Za-z0-9])*$/
  Address = /^([A-Za-z 0-9 @&*(),./'-])*$/                                                ///^([A-Za-z0-9&()",./'-` ])*$/       //      @"^[A-Za-z0-9 &'\(\)\*,\-\./@£]*$"
  city = /^([A-Za-z ,/-])*$/
  AuditorRegistrationNumber = /^([0-9])*$/
  //itemDescription = /^[a-zA-Z0-9@%*()\-';:",\.\/ ]+$/
  //itemDescription = /^[a-zA-Z0-9@%*()\-';:",\.\/ \n]+$/;
  // Allow letters, digits, your special characters, whitespace, newline, and all currency symbols
  itemDescription = /^[a-zA-Z0-9@%*()\-';:",\.\/ \n\u0024\u00A2\u00A3\u00A4\u00A5\u20A0-\u20CF]+$/;   //This will allow 36 Currency symbolls

  @Input('InputRestriction') InputRestriction: ElementRef;
  @Input('appNumberdirective') appNumberdirective: string;
  
  constructor(private control: NgControl, private element: ElementRef) {
    this.element.nativeElement.title=''
  }

  @Input('pattern') pattern: string | RegExp

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    //debugger
    let k = (event.target as Element).className
    if (k.indexOf("Balance") > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
      //else {
      //  this.control.control.setValue(s);
      //}
    }   if (k.indexOf("JournalBalance") > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
      //else {
      //  this.control.control.setValue(s);
      //}
    }
    if (k.indexOf("itemDescription") > 0) {
      debugger
      var regex = new RegExp(this.itemDescription)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("ComputationBalance") > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
      //else {
      //  this.control.control.setValue(s);
      //}
    }
    if (k.indexOf("Interest") > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s) || s.length > 6) {
        event.preventDefault();
      }
      //else {
      //  this.control.control.setValue(s);
      //}
    }
    if (k.indexOf('numberonly') > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.clipboardData.getData('text/plain').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }

    }
    if (k.indexOf("Mobile") > 0) {
      var regex = new RegExp(this.Mobile)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("StringOnly") > 0) {
      var regex = new RegExp(this.stringPattern)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, " ").trim();
      console.log(s);
      //let k =  navigator.clipboard.readText();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("Telephone") > 0) {
      //debugger;
      var regex = new RegExp(this.Telephone)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("postcode") > 0) {
      var regex = new RegExp(this.postcode)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("companyAuthenticationcode") > 0) {
      var regex = new RegExp(this.companyAuthenticationcode)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("Address") > 0) {
      var regex = new RegExp(this.Address)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("City") > 0) {
      var regex = new RegExp(this.city)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("AccountNumber") > 0) {
      var regex = new RegExp(this.AccountNumber)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("TaxReferenceNumber") > 0) {
      var regex = new RegExp(this.TaxReferenceNumber)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    } if (k.indexOf("AuditorRegistrationNumber") > 0) {
      var regex = new RegExp(this.AuditorRegistrationNumber)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("MinusValue") > 0) {
      var regex = new RegExp(this.MinusValue)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("companyname") > 0) {
      var regex = new RegExp(this.companyname)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
      if (s.includes(" "))
        event.preventDefault();
    }
    if (k.indexOf("allowSpecialChars") > 0) {
      var regex = new RegExp(this.allowSpecialChars)
      let s = event.clipboardData.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }


    //confirmpassword
    if (k.indexOf("confirmEmail") > 0) {
      event.preventDefault();
    }

  }

  @HostListener('focus', ['$event']) focus(event: any) {
     //debugger;
    let k = event.target.value;
    if (event.target.className.indexOf("Balance") > 0) {
      if (isNaN(k)) {
        event.preventDefault();
      }
      else if (k != "") {
        this.control.control.setValue(parseFloat(k));
      }
    }  if (event.target.className.indexOf("JournalBalance") > 0) {
      if (isNaN(k)) {
        event.preventDefault();
      }
      else if (k != "") {
        this.control.control.setValue(parseFloat(k));
      }
    }
    if (event.target.className.indexOf("ComputationBalance") > 0) {
      if (isNaN(k)) {
        event.preventDefault();
      }
      else if (k != "") {
        this.control.control.setValue(parseFloat(k));
      }
    }
    if (event.target.className.indexOf("Interest") > 0) {
      if (k != "") {
        this.control.control.setValue(parseFloat(k));
      }
    }
    if (event.target.className.indexOf("MTR_String") > 0) {
      //debugger;
      let k = event.target.value.trim();
      // event.target.value = k.trim();
      this.control.control.setValue(k);
    }
  }
  @HostListener('blur', ['$event']) blur(event: any) {
    //debugger;
    let k = event.target.value.trim();
    //let uppercase = event.target.value.toUpperCase();
    if (event.target.className.indexOf("Balance") > 0) {
      if (isNaN(k)) {
        this.control.control.setValue(null)
        event.preventDefault();
      }
      else if (k != "") {
        this.control.control.setValue(parseFloat(k).toFixed(2));
      }
    }   if (event.target.className.indexOf("JournalBalance") > 0) {
      if (isNaN(k)) {
        this.control.control.setValue(null)
        event.preventDefault();
      }
      else if (k != "") {
        this.control.control.setValue(parseFloat(k));
      }
    }
    if (event.target.className.indexOf("partnership") >= 0) {
      if (isNaN(k)) {
        this.control.control.setValue(null)
        event.preventDefault();
      }
      else if (k.includes("000")) {
        this.control.control.setValue(0)
      }
    }
    if (event.target.className.indexOf("ComputationBalance") > 0) {
      if (isNaN(k)) {
        this.control.control.setValue(null)
        event.preventDefault();
      }
      else if (k != "") {
        this.control.control.setValue(parseFloat(k.toFixed(2)));
      }
    }
    if (event.target.className.indexOf("Interest") > 0) {
      if (k != "") {
        this.control.control.setValue(parseFloat(k).toFixed(2));
      }
    }
    if (event.target.className.indexOf("numberonly") > 0) {
      if (k != "") {
        this.control.control.setValue(parseFloat(k));
      }
    }
    if (event.target.className.indexOf("string") > 0) {
      this.control.control.setValue(k.trim());
    }
    if (event.target.className.indexOf("caseSenstive") > 0) {
      //k = (k.split(" ").map(x => x[0]?.toUpperCase() + x.substr(1)?.toLowerCase()).join(" ")).replaceAll('undefined', '')
      this.control.control.setValue(k.trim());
    }
    if (event.target.className.indexOf("AccountNumber") > 0) {
      this.control.control.setValue(k.replace(/^0+/, '0'));
    }
    if (event.target.className.indexOf("TaxReferenceNumber") > 0) {
      this.control.control.setValue(k.replace(/^0+/, ''));
    }
    if (event.target.className.indexOf("AuditorRegistrationNumber") > 0) {
      this.control.control.setValue(k.replace(/^0+/, ''));
    }
    if (event.target.className.indexOf("companyname") > 0) {
      this.control.control.setValue(k.replaceAll(' ', ''));
    }
    if (event.target.className.indexOf("MinusValue") > 0) {
      this.control.control.setValue(k.replace(/^0+/, ''));
      var data = k.split('-');
      if (data.length == 1) {

      }
      else if (data.length == 2 && !data[0] && data[1]) {

      }
      else {
        Swal.fire("Andica Accounts Production", "Data entered does not match the desired format, refer help.", 'warning');
        this.control.control.setValue(null);
      }
    }
    if (event.target.className.indexOf("allowSpecialChars") > 0) {
      this.control.control.setValue(k.trim());
    }
    if (event.target.className.indexOf("AccountNumber") > 0) {
      if (k >= 100000000) {
        Swal.fire({
          title: 'Andica Accounts Production',
          icon: 'info',
          text: 'The value in this field must be below 100 million',
          allowOutsideClick: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.value) {
            this.control.control.setValue(null);// event.target.value = "";
            this.element.nativeElement.focus();

          } else if (result.dismiss === Swal.DismissReason.cancel) {

          }
        })
      }
    }

    //let postpattern;
    //if (event.target.className.indexOf("Postcode") > 0) {
    //  postpattern = /^((([A-Z][0-9][0-9]?)|(([A-Z][A-HJ-Y][0-9][0-9]?)|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2})$/;
    //}

    //if (event.target.className.indexOf("Mobile") > 0) {
    //  let pattern = /^(?:\d((\+44)|(0))?\d{4} ?\d{6})$/;
    //}
    if (event.target.className.indexOf("Mobile") > 0) {
      /*pattern = /^(07[\d]{8,12}|447[\d]{7,11})$/;*/
      if (k != "") {
        this.control.control.setValue(k);
      }
    }

    //if (!postpattern.test(uppercase) && uppercase != "") {
    //  Swal.fire({
    //    icon: "warning",
    //    text: "Please enter valid UK Postcode. Hence it be removed.",
    //    allowOutsideClick: false,
    //    confirmButtonText: "Ok"
    //  }).then((result) => {
    //    if (result.value) {
    //      this.control.control.setValue(null);
    //    }
    //  });
    //}
  }
  @HostListener('keypress', ['$event']) keypress(event: any) {
   //debugger
    const position = this.element.nativeElement.selectionStart;
    let k = event.target.value + event.key;
    //if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'Backspace', 'Tab', 'Alt', 'Shift', 'Control', 'Enter', 'Delete', 'Meta'].includes(event.key)) {
    //  return true;
    //}
    //if (event.key === 'a' && event.ctrlKey === true || event.key === 'c' && event.ctrlKey === true || event.key === 'v' && event.ctrlKey === true || event.key === 'x' && event.ctrlKey === true || event.key === 'z' && event.ctrlKey === true || event.key === 'C' && event.ctrlKey === true || event.key === 'x' && event.ctrlKey === true || event.key === 'A' && event.ctrlKey === true || event.key === 'V' && event.ctrlKey === true || event.key === 'Z' && event.ctrlKey === true) {
    //  return true;
    //}
    if (event.target.className.indexOf("numberonly") > 0) {
      //var pattern = "^(?:\d{1,11}|[0-9]*(\.[0-9]{0,2}))$"
      var regex = new RegExp(this.AccountNumber)
      var str = event.target.value + event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("Balance") > 0) {
      var regex = new RegExp(this.pattern)
      var regex1 = new RegExp('-?[1-9][0-9]*$')
      var str = event.target.value + event.key;
      if (regex.test(str) && str.split('-').length < 3) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("JournalBalance") > 0) {
      var regex = new RegExp(this.pattern)
      var regex1 = new RegExp('-?[1-9][0-9]*$')
      var str = event.target.value + event.key;
      if (regex.test(str) && str.split('-').length < 3) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    const allowedControlKeys = ['Enter', 'Backspace', 'Tab'];
    const key = event.key;
    if (allowedControlKeys.includes(key)) return;
    if (event.target.className.indexOf("itemDescription") > 0) {
      debugger
      var regex = new RegExp(this.itemDescription)
      var str = event.target.value + event.key;
      if (!regex.test(str)) {
        event.preventDefault();
      }
    }
    if (event.target.className.indexOf("ComputationBalance") > 0) {
      var regex = new RegExp(this.pattern)
      var str = event.target.value + event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("allowSpecialChars") > 0) {
      var regex = new RegExp(this.allowSpecialChars)
      let str = event.target.value + event.key;
      if (!regex.test(str)) {
        event.preventDefault();
      }
    }
    if (event.target.className.indexOf("Interest") > 0) {
      var regex = new RegExp(this.pattern)
      var str = event.target.value + event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("Mobile") > 0) {
      // debugger;
      var regex = new RegExp(this.Mobile)
      var str = event.key;
      if (str == '+' && position != 0) {
        return false;
      }
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("AccountNumber") > 0) {
      var regex = new RegExp(this.AccountNumber)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("TaxReferenceNumber") > 0) {
      var regex = new RegExp(this.TaxReferenceNumber)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    } if (event.target.className.indexOf("AuditorRegistrationNumber") > 0) {
      var regex = new RegExp(this.AuditorRegistrationNumber)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("MinusValue") > 0) {
      var regex = new RegExp(this.MinusValue)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("companyname") > 0) {
      var regex = new RegExp(this.companyname)
      var str = event.key;
      if (event.key == " ")
        event.preventDefault();
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("StringOnly") > 0) {
      var regex = new RegExp(this.stringPattern)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("Telephone") > 0) {
      var regex = new RegExp(this.Telephone)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("Address") > 0) {
      var regex = new RegExp(this.Address)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("City") > 0) {
      var regex = new RegExp(this.city)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("postcode") > 0) {
      var regex = new RegExp(this.postcode)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("companyAuthenticationcode") > 0) {
      var regex = new RegExp(this.companyAuthenticationcode)
      var str = event.key;
      if (regex.test(str)) {
        return true;
      }
      else {
        event.preventDefault();
        return false;
      }
    }
    if (event.target.className.indexOf("postcode") > 0) {
      return true;
    }
    if (event.target.className.indexOf("Mobile") > 0) {
      if (event.target.value.indexOf("-") == -1 && k == "-") {
        return true;
      }
    }
    if (event.target.className.indexOf("Negative") > 0) {
      if (event.target.value.indexOf("-") == -1 && k == "-") {
        return true;
      }
    }
    if (event.target.className.indexOf("partnership") >= 0) {
      debugger
      var regex = new RegExp(/^\d*\.?\d{0,2}$/g)
      var currentvalue = event.target.value
      var val = [currentvalue?.slice(0, position), event.key == "Decimal" ? "." : event.key, currentvalue?.slice(position)].join('')
      if (position == 0) {
         val = event.key
        event.target.value = '';
        event.target.remove.length;
      }
      //else
      //  val = val + event.key;
      if (event.key != "") {
        if (val?.split('.')[0].length > 2 && val?.split('.')[0]!="100") {
          event.target.value = '';
          event.target.remove.length;
        }
      }
      var str:any = val;
      //var x = str.split()

      if (+str <= 100) {
        if (regex.test(str)) {
          return true;
        }
        else {
          event.preventDefault();
          return false;
        }
      }
      else {
        event.preventDefault();
        return false;
      }

    }
    return true;
  }
  @HostListener('drop', ['$event']) ondrop(event: DragEvent) {
     //debugger
    let k = (event.target as Element).className
    if (k.indexOf("Balance") > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }    if (k.indexOf("JournalBalance") > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("itemDescription") > 0) {
      debugger
      var regex = new RegExp(this.itemDescription)
      let s = event.dataTransfer.getData('text/plain').replace(/\s|\n/g, ' ').trim();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("ComputationBalance") > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("numberonly") > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("Interest") > 0) {
      var regex = new RegExp(this.pattern)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s) || s.length > 6) {
        event.preventDefault();
      }
    }
    if (k.indexOf("Mobile") > 0) {
      var regex = new RegExp(this.Mobile)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("StringOnly") > 0) {
      var regex = new RegExp(this.stringPattern)
      let s = event.dataTransfer.getData('text/plain');
      //let k =  navigator.clipboard.readText();
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("Telephone") > 0) {
      var regex = new RegExp(this.Telephone)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("postcode") > 0) {
      var regex = new RegExp(this.postcode)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("companyAuthenticationcode") > 0) {
      var regex = new RegExp(this.companyAuthenticationcode)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("Address") > 0) {
      var regex = new RegExp(this.Address)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("AccountNumber") > 0) {
      var regex = new RegExp(this.AccountNumber)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("TaxReferenceNumber") > 0) {
      var regex = new RegExp(this.AccountNumber)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("AuditorRegistrationNumber") > 0) {
      var regex = new RegExp(this.AccountNumber)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("MinusValue") > 0) {
      var regex = new RegExp(this.MinusValue)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("Companyname") > 0) {
      var regex = new RegExp(this.companyname)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("City") > 0) {
      var regex = new RegExp(this.city)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }
    if (k.indexOf("allowSpecialChars") > 0) {
      var regex = new RegExp(this.allowSpecialChars)
      let s = event.dataTransfer.getData('text/plain');
      if (!regex.test(s)) {
        event.preventDefault();
      }
    }

  }




}




